module.exports = __webpack_public_path__ + "img/a time when the girl lived_.2b713e67.png";